
import { useState, useEffect, useCallback } from 'react';
import { getGameHoleBirdies, GameHoleBirdieRecord } from '@/integrations/supabase/scores/scoreHistoryService';

interface UseGameBirdieRecordsParams {
  gameId?: string;
  gameIds?: string[];
  courseId?: string;
  holeNumber?: number | null;
}

export function useGameBirdieRecords({ gameId, gameIds, courseId, holeNumber }: UseGameBirdieRecordsParams) {
  const [records, setRecords] = useState<GameHoleBirdieRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const hasGameIds = (gameIds && gameIds.length > 0) || !!gameId;

  useEffect(() => {
    if (!hasGameIds || !courseId || !holeNumber) {
      setRecords([]);
      return;
    }

    const load = async () => {
      setIsLoading(true);
      const data = await getGameHoleBirdies({
        gameId,
        gameIds,
        courseId,
        holeNumber,
      });
      setRecords(data);
      setIsLoading(false);
    };
    load();
  }, [gameId, gameIds?.join(','), courseId, holeNumber, fetchTrigger]);

  const refreshRecords = useCallback(() => {
    setFetchTrigger(prev => prev + 1);
  }, []);

  return { records, isLoading, refreshRecords };
}
